// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const GridFilledIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M13 13v9h7a2 2 0 002-2v-7h-9zm7-11h-7v9h9V4a2 2 0 00-2-2zM4 2a2 2 0 00-2 2v7h9V2H4zM2 13v7a2 2 0 002 2h7v-9H2z"/></svg>'} />;

GridFilledIcon.displayName = 'GridFilledIcon';

export default GridFilledIcon;
